import { Link } from 'react-router-dom'
import { AppActionType, useAppDispatch, useAppState } from '@context/AppContext'
import { useUserState } from '@services/user/UserContext'
import { ApiType } from '@services/ApiType'
import { environment } from '@environment'
import { UserAccount } from '@common/UserAccount'
import { UserPermission } from '@common/UserPermission'
import { FormEvent, useRef } from 'react'

import './Footer.styles.scss'

import OpenSea from '@assets/landing-page-v3/logos/OpenSea.svg'
import Etherscan from '@assets/landing-page-v3/logos/Etherscan.svg'
import Discord from '@assets/landing-page-v3/logos/Discord.svg'
import Twitter from '@assets/landing-page-v3/logos/Twitter.svg'

function hasAdminPerm(userState: UserAccount) {
  return userState.permissions.includes(UserPermission.Admin);
}

export function Footer() {
  const userAccount = useUserState()
  const appState = useAppState()
  const appDispatch = useAppDispatch()
  const emailFieldRef = useRef<HTMLInputElement>()

  if (!appState.showFooter) {
    return null
  }

  function submitSignUpEmail(e: FormEvent) {
    e.preventDefault()

    if (!emailFieldRef.current) {
      return
    }

    // open modal with predefined email
    appDispatch({
      type: AppActionType.UpdateSignUpEmail,
      email: emailFieldRef.current.value,
      showSignUpModal: true,
    })

    // scroll up
    window.location.hash = '#top'
  }

  const showMockLinks = environment.userServiceApi === ApiType.Mock && userAccount.loggedIn
  return (
    <footer className={'Footer'}>
      <div className={'LinkContainer'}>
        <div>
          <p>Create</p>
          <Link to='/create'>Create</Link>
          <a href='/about#about'>About</a>
          {appState.features.showMapLink && <Link to='/maps'>Maps</Link>}
          {appState.features.showWhitepaperLink && <Link to='/whitepaper'>Whitepaper</Link>}
        </div>
        <div>
          <p>About</p>
          <Link to='/tos'>TOS</Link>
          <Link to='/privacy'>Privacy Policy</Link>
          <Link to='/copyright'>Copyright</Link>
          <Link to='/cookies'>Cookies</Link>
        </div>
        <div>
          <p>Resources</p>
          <Link to='/founderspassterms'>Founder's Pass TOS</Link>
          {appState.features.showContactsSection && (
            <a href='/about#contact'>Contact</a>
          )}
        </div>
        {showMockLinks && (
          <div>
            <p>Mock</p>
            {hasAdminPerm(userAccount) && (<>
              <Link to ='/admin'>Admin</Link>
            </>)}
            <Link to='/logout'>Log out</Link>
          </div>
        )}
      </div>

      <div className='Right'>
        { appState.features.showFooterSignUp && (
          <div className='EmailSignup'>
            <p>Sign up for our future drops</p>

            <form onSubmit={submitSignUpEmail}>
              <input type='email' placeholder='Email Address' ref={emailFieldRef} />
              <button type='submit'></button>
            </form>
          </div>
        )}

        <div className='SocialLinks'>
          <a href='https://opensea.io/collection/storyverse-plots' target='_blank'>
            <img src={OpenSea} alt='OpenSea' />
          </a>
          <a href='https://etherscan.io/address/0x3A7011e7E2b32C2B52f7De1294Ff35d6ff20310F' target='_blank'>
            <img src={Etherscan} alt='Etherscan' />
          </a>
          {/* <a href='' target='_blank'>
            <img src={YouTube} alt='YouTube' />
          </a>
          <a href='' target='_blank'>
            <img src={Instagram} alt='Instagram' />
          </a>
          <a href='' target='_blank'>
            <img src={TikTok} alt='TikTok' />
          </a> */}
          <a href='https://discord.com/invite/storyverse' target='_blank'>
            <img src={Discord} alt='Discord' />
          </a>
          <a href='https://twitter.com/storyverse_xyz' target='_blank'>
            <img src={Twitter} alt='Twitter' />
          </a>
        </div>
      </div>
    </footer>
  )
}
